import React from 'react';
import data from '../../../data/innerpages/single_project/chat.json';

function Chat() {
  return (
    <section className="tc-chat-style1">
      <div className="container">
        <div className="content">
          <a href={`mailto:${data.email}`} className="xl-text js-splittext-lines">
            {data.email}
          </a>
          <h5 className="mb-50 lh-5">
            {data.heading}
          </h5>
        </div>
      </div>
      <img
        src="/innerpages/assets/img/c_line4.png"
        alt=""
        className="c-line wow"
      />
    </section>
  );
}

export default Chat;
